import { Component, EventEmitter, OnInit, Output, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Department } from "../../../model/departments";
import { Messages } from "../../../model/messages";
import { DepartmentsService } from "../../../services/departaments.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Navigation } from "../../../model/navigation";
import { SingleChoice } from "../../../model/singlechoice";
import { NavigationHelper } from "../../../services/navigation.helper";

@Component({
    selector: "departments",
    templateUrl: "./departments.component.html",
    styleUrls: ["./departments.component.css"],
})
export class DepartmentsComponent implements OnInit {
    departmentCount: number = 0;
    departments: BehaviorSubject<Department[]>;
    filteredDepartment: BehaviorSubject<Department[]> = new BehaviorSubject<
        Department[]
    >([]);
    searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
    selectedDepartment: Department | null = null;
    messages: BehaviorSubject<Messages>;
    title: BehaviorSubject<string> = new BehaviorSubject<string>("");
    @Output() departmentSelected = new EventEmitter<number>();
    @Output() createNew = new EventEmitter<void>();
    @Input() choiceEvent: SingleChoice = SingleChoice.EMPTY;
    @Input() isMobile: boolean = false;

    constructor(
        private departmentsService: DepartmentsService,
        private auth: AuthService,
        private router: Router,
        private nav: NavigationHelper
    ) {
        this.messages = new BehaviorSubject(Messages.EMPTY);
        this.departments = new BehaviorSubject<Department[]>([]);
    }

    ngOnInit(): void {
        this.title.next("departments.title");
        const token = this.auth.token;

        this.departmentsService.departments(token).subscribe({
            next: (messages) => {
                if (messages.hasAnyMessages) {
                    this.messages.next(messages);
                }
            },
        });

        this.departmentsService.departmentsObservable.subscribe((data) => {
            const sortedDepartments = [...data].sort(
                (a: Department, b: Department) =>
                    a.name.localeCompare(b.name)
            );
            this.departments.next(sortedDepartments);
            this.filteredDepartment.next(sortedDepartments);
            this.departmentCount = sortedDepartments.length;
        });
    }
    searchDepartments(): void {
        const query = this.searchTerm.getValue().toLowerCase();
        const filtered = query
            ? this.departments.value.filter((departments) =>
                departments.name.toLowerCase().includes(query)
            )
            : this.departments.value;
        this.filteredDepartment.next(filtered);
    }

    clearDepartmentsFilter(): void {
        this.searchTerm.next("");
        this.filteredDepartment.next(this.departments.value);
    }

    select(department: Department) {
        this.selectedDepartment = department;
        if (this.choiceEvent && this.choiceEvent.topic == "departments") {
            if (department && department.id) {
                this.departmentsService
                    .makeBackgroundColor(department.id)
                    .subscribe((color) => {
                        const background = color;
                        this.departmentsService
                            .makeColor(department.id!!)
                            .subscribe((c) => {
                                const color = c;
                                this.choiceEvent.choose(
                                    department.id!!,
                                    department.name,
                                    background,
                                    color,
                                    1
                                );
                            });
                    });
            }
        } else {
            this.departmentsService.select(department);

            if (department && department.id) {
                this.router
                    .navigate([`departments/${department.id}/fragment/department-user`])
                    .then(() => {
                        this.departmentSelected.emit(department.id!!);
                    });
            }
        }
    }

    createNewDepartment() {
        this.createNew.emit();

        const newDepartment = new Department(Navigation.NEW, "");
        this.departmentsService.select(newDepartment);
        this.router.navigate([`departments/` + Navigation.NEW]).then(() => {
            this.departmentSelected.emit(Navigation.NEW);
        });
    }
}
